
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import { get_token,get_user_details } from "@/router";
import Swal from "sweetalert2";
import { ref } from "vue";
const domain = window.location.hostname;

export default {
  components: {
    HomeNavBar,
  },

  mounted() {
    this.user.user_id = this.$route.query.user_id
    this.user_details = get_user_details();
    this.token_exists = get_token();
    this.fetch_races();
    this.fetch_gender();
    this.fetch_title();
    this.fetch_province();
    this.get_rating();
    this.get_profile();
    
    
    this.filter_membership_payment_history();
    this.fetch_type_of_organization();
    this.fetch_type_of_profile();
    if(domain.includes('tdm') || domain.includes('chamber') || domain.includes('staging') || domain.includes('uat.workstreams')|| domain.includes('demo.workstreams')){
      this.profile_domain=true
    }
    if(domain.includes('workbook')) {
      this.workbook_domain = true;
    }

    if (domain.includes('dwypd') || domain.includes('soulcity')) {
      this.dwypd_domain = true;
    }
    if(domain.includes('cbo')) {
      this.cbo_domain = true;
    }

    if (this.user_details.user_id===this.user.user_id) {
      this.user.first_name = this.user_details.first_name || '';
      this.user.last_name = this.user_details.last_name || '';
      this.user.email =this.user_details.email || '';
      this.user.phone_number =this.user_details.phone_number || '';
      
    }
  },

  data() {
    return ({
    user: this.getUserData(),
      races: [],race_id: '',
      genders: [],
      titles: [],title_id: '',
      cv: null,
      profile_picture_url: null,
      skills : [],
      work_experiences: [],
      educations: [],
      fileType: '',
      isLocalFile: false,
      local_file_url:null,
      address:this.get_address(),
      rating: 0,
      totalRatings: 0,
      profileData:[],
      user_details: {
        "user_role": '',
      },
      token_exists: true,
      isLoading: false,
      profile: {},
      errors: {},
      showPreview: false,
      file_name: '',
      membership_payment_history_id: null,
      membership_payment_history: [],
      membership_name:'',
      membership_type:'',
      membership_price:0,
      userHasPaid: false,
      billing_cycle:'',
      type_of_profile: [],
      base_profiles: [],
      displayLetter: '',
      profile_questions: [],
      workbook_domain: false,
      dwypd_domain: false,
      renewal_date: null,
      is_active: false,
      is_cancelled: false,
      filtered_profiles: [],
      showVisibilityModal:false,
      currentField: '',
      currentVisibility: true,
      visibilityOptions: {
      true: 'Public',
      false: 'Only Me'
    },
      profile_domain: false,
      activeTab: 'about',
      cbo_domain: false,
      location: '',
      profilePicture: null,
      profilePicturePreview: null,
      fully_answered_sections: {} ,
      question_page: 1,
      questions_per_page: 5,

    });
  },
  setup() {
    const subscriptionExpanded = ref(false);
    const showManagement = ref(false);

    return { subscriptionExpanded, showManagement };
  },
  props: {
  business_profiles: {
    type: Array,
    default: () => []
  },
  selectedLocation: {
    type: String,
    default: ''
  },
},
computed: {

  circleOffset() {
    const radius = 54;
    const circumference = 2 * Math.PI * radius;
    return circumference - (this.profileCompletion / 100) * circumference;
  },

profileImageUrl() {
    const files = this.profile_data?.profile_files || [];
    return files.length > 0 ? files[0].file.s3_url : require('@/assets/images/user.svg');
  },
    all_section() {
    // questions is an array of forms, each with form_sections (sections)
    return this.profile_questions.flatMap(form =>
      (form.form?.form_sections || []).map(fs => ({
        ...fs,
        formId: form.form?.id,
        formName: form.form?.name,
        section: fs.section,
        sectionId: fs.section?.id
      }))
    );
  }
  },
  watch: {

  all_section: {
    immediate: true,
    handler() {
      if (this.profileData && this.all_section) {
        this.initialize_answers();
      }
    }
  },
  selectedLocation(newVal) {
    if (newVal) {
      this.location = newVal;
    }
  }
},
  methods: {

    is_valid_value(value) {
    return value && value.trim().toLowerCase() !== 'n/a';
  },

    isValidField(val) {
    return val && typeof val === 'string' && val.trim().toLowerCase() !== 'n/a';
  },
    triggerFileUpload() {
    this.$refs.fileInput && this.$refs.fileInput.click();
  },

  onProfilePictureChange(event) {
    const file = event.target.files[0];
    if (file) {
      this.profilePicture = file;
      this.profilePicturePreview = URL.createObjectURL(file);
      $('#image_preview_modal').modal('show');
    }
  },

    upload_profile_picture() {
  const formData = new FormData();
  if (this.profilePicture) {
    if (this.profilePicture instanceof File) {
      formData.append('file', this.profilePicture);
    }
  }

  Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we upload your profile picture.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/upload_profile_picture/`,
    type: 'POST',
    headers: {
      Authorization: `Token ${get_token()}`,
    },
    data: formData,
    processData: false,
    contentType: false,
    success: (response) => {
      this.profilePicturePreview = response?.file?.s3_url || null;
      this.profilePicture = null;

      Swal.fire({
        title: 'Profile Picture Uploaded Successful',
        text: 'Your profile picture has been uploaded successfully.',
        icon: 'success',
        timer: 1000,
        showConfirmButton: false
      }).then(() => {
        this.get_profile();
        $('#image_preview_modal').modal('hide');
      })
    },
    error: (xhr, status, error) => {
      console.error('Error uploading profile picture:', error);
      Swal.fire('Upload Failed', 'An error occurred while uploading the profile picture.', 'error');
    }
  });
},

    open_business_profile(profile) {
      const base = profile.id;
      const type = profile.profile_type;
      window.location.href = `/customer_profile?base=${base}&type=${type}`;
    },
      on_dynamic_tab_click(section) {

        const sectionId = section.sectionId || section.section?.id;
        this.activeTab = 'section_' + sectionId;
      },
    getUserData() {
        let user={ first_name: '',
            last_name: '',
            email: '',
            gender_id: '',
            date_of_birth: '',
            phone_number: '',
            user_id: '',
            newSkill: '' }
        return user;
    },
    get_address() {
        let address = {
            street_address: '',
            town: '',
            postal_code: '',
            province_id: '',
            }
      return address
    },
    get_profile() {
        this.isLoading = true;
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile/`,
          type: 'GET',
          headers: {
            Authorization: `Token ${get_token()}`,
            'Content-Type': 'application/json',
          },
          data: {
            user_id: this.user.user_id
          },
          success: (data) => {
            if (data.status === 'success' && data.data.profile_data) {
                this.profileData = data.data.profile_data;
                this.user.date_of_birth = this.profileData.date_of_birth || '';
                this.user.email= this.profileData.email || '';
                this.location = this.profileData.location || '';
                this.address.street_address = this.profileData.street_address || '';
                this.address.town = (this.profileData.town || '').charAt(0).toUpperCase() + (this.profileData.town || '').slice(1).toLowerCase();
                this.address.postal_code = this.profileData.postal_code || '';


              if (this.profileData.profile_files && this.profileData.profile_files.length > 0) {
                this.profile_picture_url = this.profileData.profile_files[0].file.file_url;
                this.cv = this.profileData.profile_files[0].file;
                this.file_name = this.profileData.profile_files[0].file.name;
              } else {
                this.cv = null;
              }

              for (const race of this.races) {
                if (race.race === this.profileData.race) {
                  this.race_id = race.id;
                  break;
                }
              }

              // Match Gender
              for (const gender of this.genders) {
                if (gender.gender === this.profileData.gender) {
                  this.user.gender_id = gender.id;
                  break;
                }
              }

              // Match Province
              for (const province of this.provinces) {
                if (province.province_name === this.profileData.province) {
                  this.address.province_id = province.id;
                  this.province_name = province.province_name;
                  break;
                }
              }

              // Match Title
              for (const title of this.titles) {
                if (title.title === this.profileData.title) {
                  this.title_id = title.id;
                  break;
                }
              }
            }
            if (this.profileData.visibility) {
              this.visibilitySettings = {
                ...this.visibilitySettings,
                ...this.profileData.visibility
              };
            }
          },
          complete: () => {
            this.isLoading = false;
          },
        });
      },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },

    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user.user_id) {

        this.user.user_id = this.user_details.user_id;
      }

      const payload = {
        filter_values: {
          user_id: this.user.user_id,

        }
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify(payload),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {"Content-Type": "application/json" },
        success: (response) => {
          this.membership_payment_history = response.data.payment_history;

          this.userHasPaid = this.membership_payment_history.some(
            (payment) => payment.payment_status?.status === "paid"
          );
          this.is_cancelled = this.membership_payment_history.some(
            (payment) => payment.payment_status?.status === "cancelled"
          );

          this.is_active = this.membership_payment_history[0]?.is_active || false;
          this.membership_payment_history_id = this.membership_payment_history[0]?.id || null;
          this.membership_name =this.membership_payment_history[0]?.membership?.name || '';
          this.membership_type = this.membership_payment_history[0]?.membership?.membership_type.name || '';
          this.billing_cycle = this.membership_payment_history[0]?.membership?.billing_cycle?.name || '';
          this.membership_price = this.membership_payment_history[0]?.membership?.membership_pricing[0]?.price || 0;
          this.renewal_date = this.membership_payment_history[0]?.valid_until|| null;
        },
        complete: () => {
          this.isLoading = false;
        },
      })
    },

    navigate_to_plans() {
    $('#manage-subscription-modal').modal('hide');
    // Navigate after modal is hidden
    setTimeout(() => {
      this.$router.push('/view_membership/');
    }, 100); // wait for the modal to fully close
  },
    cancel_membership() {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, cancel it!'
      }).then((result) => {
        if (result.isConfirmed) {
$.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/cancel_membership/`,
        method: "POST",
        data: JSON.stringify({ membership_id: this.membership_payment_history_id }),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {"Content-Type": "application/json" },
        success: (response) => {
          if( response.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Membership cancelled successfully',
            })
            $('#manage-subscription-modal').modal('hide');
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      })
      }
      })
    },

    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle('close');
    },

    toggleCheckbox(qa, optionValue, isChecked) {
  // Ensure qa.newAnswer is an array for checkboxes
  if (!Array.isArray(qa.newAnswer)) {
    // If qa.newAnswer is a string, split by comma and trim
    if (typeof qa.newAnswer === 'string' && qa.newAnswer.length > 0) {
      qa.newAnswer = qa.newAnswer.split(',').map(opt => opt.trim());
    } else {
      qa.newAnswer = [];
    }
  }

  if (isChecked) {
    if (!qa.newAnswer.includes(optionValue)) {
      qa.newAnswer.push(optionValue);
    }
  } else {
    const index = qa.newAnswer.indexOf(optionValue);
    if (index > -1) {
      qa.newAnswer.splice(index, 1);
    }
  }
},

    get_rating() {
      if (!this.user_id) {
      
        this.user_id = this.user_details.user_id;
      }
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_profile_rating/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: {
          user_id: this.user_id
        },
        success: (response) => {
          if (response.status === 'success') {
            this.rating = response.data.average_rating;
            this.totalRatings= response.data.total_count

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    saveRating(ratingValue) {
      this.rating = ratingValue;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_profile_rating/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ user_id: this.user_id, rating: this.rating }),
        success: (response) => {
          if (response.status === "success") {
            this.rating = response.data.average_rating;
            this.totalRatings= response.data.total_count
          }
        },
      });
    },

    handle_file_upload(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (this.validateFile(file)) {
          this.cv = file;
          this.file_name = file.name;
          this.fileType = file.type;
          this.local_file_url = URL.createObjectURL(file);
          this.isLocalFile = true;
          this.showPreview = true;
          this.errorMessage = '';  // Clear error message
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Invalid File Type',
            text: 'Only PDF and Word documents are allowed.',
          });
          this.resetFileUpload();
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'No File Selected',
          text: 'Please select a file to upload.',
        });
        this.resetFileUpload();
      }
    },
    validateFile(file) {
      const allowedTypes = ['application/pdf', 'application/msword'];

      if(allowedTypes.includes(file.type)) {
        return true;
      } else {
        return false;
      }
    },

    resetFileUpload() {
      // Reset the file upload fields
      this.cv = null;
      this.local_file_url = null;
      this.fileType = '';
      this.file_name = '';
      this.isLocalFile = false;
      this.showPreview = false;
      this.errorMessage = '';  // Reset error message
    },
    validationProfileForm() {
      this.errors = {};
      let valid = true;
    
      // First name
      if (!this.user.first_name || this.user.first_name.trim() === '') {
        this.errors.first_name = 'First name is required';
        valid = false;
      }
    
      // Last name
      if (!this.user.last_name || this.user.last_name.trim() === '') {
        this.errors.last_name = 'Last name is required';
        valid = false;
      }
    
      // Email
      if (!this.user.email || this.user.email.trim() === '') {
        this.errors.email = 'Email is required';
        valid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user.email)) {
        this.errors.email = 'Enter a valid email address';
        valid = false;
      }
    
      // Phone number
      if (!this.user.phone_number || this.user.phone_number.trim() === '') {
        this.errors.phone_number = 'Phone number is required';
        valid = false;
      } else if (!/^\+?\d{7,15}$/.test(this.user.phone_number)) {
        this.errors.phone_number = 'Enter a valid phone number';
        valid = false;
      }
    
      // Location
      if (!this.location || this.location.trim() === '') {
        this.errors.location = 'Location is required';
        valid = false;
      }
    
      // Date of birth
      if (!this.user.date_of_birth || this.user.date_of_birth === '' || this.user.date_of_birth === 'N/A') {
        this.errors.date_of_birth = 'Date of birth is required';
        valid = false;
      }
    
      // Race
      if (!this.race_id || this.race_id === '') {
        this.errors.race_id = 'Race is required';
        valid = false;
      }
    
      // Gender
      if (!this.user.gender_id || this.user.gender_id === '') {
        this.errors.gender_id = 'Gender is required';
        valid = false;
      }
    
      // Title
      if (!this.title_id || this.title_id === '') {
        this.errors.title_id = 'Title is required';
        valid = false;
      }
    
      // Province
      if (!this.address.province_id || this.address.province_id === '') {
        this.errors.province_id = 'Province is required';
        valid = false;
      }
    
      // Street Address (if visible)
      if (!this.address.street_address || this.address.street_address.trim() === '') {
        this.errors.street_address = 'Street address is required';
        valid = false;
      }
    
      // Town (if visible)
      if (!this.address.town || this.address.town.trim() === '') {
        this.errors.town = 'Town is required';
        valid = false;
      }
    
      // Postal Code (if visible)
      if (!this.address.postal_code || this.address.postal_code.trim() === '') {
        this.errors.postal_code = 'Postal code is required';
        valid = false;
      }
    
      return valid;
    },
    

    getOptionValue(answerId, options) {

      if (!options || !Array.isArray(options)) {
        return null; // Return null if options is not an array
      }

      const normalizedAnswerIds = Array.isArray(answerId)
        ? answerId.map(id => (typeof id === 'string' ? parseInt(id, 10) : id))
        : [typeof answerId === 'string' ? parseInt(answerId, 10) : answerId];

      // Filter options to find all matches
      const matchedOptions = options.filter(opt => normalizedAnswerIds.includes(opt.id));

      // If answerId is an array (checkboxes), return all matched options' values
      if (Array.isArray(answerId)) {
        return matchedOptions.map(opt => opt.option);
      }
      return matchedOptions.length > 0 ? matchedOptions[0].option : null;
    },

    saveProfile() {

      if (!this.validationProfileForm()) {
        return;
      }

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we create the profile.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.isLoading = true;
      const formData = new FormData();
      formData.append('first_name', this.user.first_name);
      formData.append('last_name', this.user.last_name);
      formData.append('email', this.user.email);
      formData.append('date_of_birth', this.user.date_of_birth);
      formData.append('gender_id', this.user.gender_id);
      formData.append('race_id', this.race_id);
      formData.append('title_id', this.title_id);
      formData.append('phone_number', this.user.phone_number);
      formData.append('street_address', this.address.street_address);
      formData.append('location', this.location);
      formData.append('town', this.address.town);
      formData.append('postal_code', this.address.postal_code);
      formData.append('province_id', this.address.province_id);
      const answeredQuestions = this.profile_questions
          .filter(question => question.answer !== undefined && question.answer !== null)
          .map(question => ({
            question_id: question.question.id,
            // Convert checkbox answers to a comma-separated string
            answer: Array.isArray(question.answer) ? question.answer.join(', ') : question.answer
          }));
        formData.append('answers', JSON.stringify(answeredQuestions));
        formData.append('base_profile', this.profileData.base_profile?.id);

      if (this.profilePicture) {
        if (this.profilePicture instanceof File) {
          formData.append('file', this.profilePicture);
        }
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_user_profile/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (body) => {
          if (body.status === 'success') {

            this.fetch_races();
            this.fetch_gender();
            this.fetch_title();
            this.fetch_province();


            Swal.fire({
              title: 'Success',
              text: 'Profile Created Successfully',
              icon: 'success',
              timer: 1000,
              showConfirmButton: false,
            }).then(() => {
              this.get_profile();
            });
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });

    this.isLoading = true;


    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_user_profile/`,
      type: 'POST',
      headers: {
        Authorization: `Token ${get_token()}`,
      },
      data: formData,
      processData: false,
      contentType: false,


      success: (data) => {
        if (data.status === 'success') {
             // Dynamically append the updated profile info
            this.fetch_races();
            this.fetch_gender();
            this.fetch_title();
            this.fetch_province();
    
            Swal.fire({
                title: 'Success',
                text: 'Profile Updated Successfully',
                icon: 'success',
                timer: 1000,
                showConfirmButton: false,
            }).then(() => {
              this.get_profile();
              $('#profile_modal').modal('hide');
          });
        }
    },
      complete: () => {
        this.isLoading = false;

      },
    })


    },

    appendProfileInfo(profileData) {
      // Dynamically update the UI with the saved profile information
      this.user.first_name = profileData.first_name;
      this.user.last_name = profileData.last_name;
      this.user.date_of_birth = profileData.date_of_birth;
      this.address.street_address = profileData.street_address;
      this.address.town = profileData.town;
      this.address.postal_code = profileData.postal_code;
      this.address.province_id = profileData.province_id;
      this.skills = profileData.skills || [];
      this.work_experiences = profileData.work_experiences || [];
      this.educations = profileData.educations || [];
      const profilePicFile = (profileData.profile_files || []).find(file =>
    file.file && file.file.file_url
    );
  this.profile_picture_url = profilePicFile?.file?.file_url || null;
      this.file_name = profileData.file_name || '';
  },

    previewDocument() {
      if(this.profile_picture_url) {
        this.showPreview = true;
        this.isLocalFile = false;
      }
    },
    closeModal() {
      this.showPreview = false;
      URL.revokeObjectURL(this.cvUrl);
      this.profile_picture_url = '';
    },
    fetch_races() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_races/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.races = response.data.race_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    fetch_gender() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_genders/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.genders = response.data.gender_data;

            

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    fetch_title() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_titles/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.titles = response.data.title_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    fetch_province() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_provinces/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.provinces = response.data.province_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    addSkill() {
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('skills_name', this.newSkill);

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/add_skills_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {

          this.$emit('addSkill',response.message)
          Swal.close();

          Swal.fire({
            icon: 'success',
            title: 'Skill Added',
            showConfirmButton: false,
            timer: 1000
          }).then(() => {
            this.skills.push(this.newSkill);
            this.newSkill = '';
            $('#addSkillModal').modal('hide');
            Swal.close();
            this.isDropdownVisible = false;
          });
        },
        error: (response) => {
          const response_data=response.responseJSON
          Swal.close();
          if(response_data.status==="error"){
            this.errors.newSkill=response_data.message
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },


    fetch_type_of_organization() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_organization = response.data.type_of_organization_data;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    update_answer(questionId, value) {
      // Find the question object by its ID
      const question = this.profile_questions.find(q => q.question.id === questionId);
      
      // Update the answer for the question
      if (question) {
        question.answer = value; // Update with the selected value
      }
    },
  
    // Handle checkbox answers (multiple selections allowed)
    toggle_checkbox_answer(questionId, option, isChecked) {
      const question = this.profile_questions.find(q => q.question.id === questionId);
      
      if (question) {
        // Initialize the answer as an empty array if it's undefined
        if (!Array.isArray(question.answer)) {
          question.answer = [];
        }
        
        // If the checkbox is checked, add the option to the answer
        if (isChecked) {
          question.answer.push(option);
        } else {
          // Otherwise, remove it from the answer
          const index = question.answer.indexOf(option);
          if (index !== -1) {
            question.answer.splice(index, 1);
          }
        }
      }
    },
    fetchProfiles() {
      this.isLoading = true;
      const payload={
        user_id: this.user.user_id
      }
      $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profiles/`,
          type: 'POST',
          headers: {
              Authorization: `Token ${get_token()}`,
              'Content-Type': 'application/json',
          },
          data: JSON.stringify(payload), // Pass user_id to filter profiles
          success: (response) => {
              if (response.status === 'success' && response.data.profiles) {
                  this.base_profiles = response.data.profiles;
                  // const current_base_id = this.profileData?.base_profile?.id;
                 const personalType = this.type_of_profile.find(
                (type) => type.name.toLowerCase() === 'business'
              );

              if (personalType) {
                this.filtered_profiles = this.base_profiles.filter(
                  (profile) => profile.profile_type === personalType.id
                );
              } else {
                this.filtered_profiles = [];
              }
          }
          },
          complete: () => {
              this.isLoading = false;
          }
      });
  },
fetch_type_of_profile() {
  this.isLoading = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_type_of_profile/`,
    type: 'GET',
    headers: {
      Authorization: `Token ${get_token()}`,
      'Content-Type': 'application/json',
    },
    success: (response) => {
      if (response.status === 'success') {
        this.type_of_profile = response.data.type_of_profile_data;

        this.show_questions()
        this.fetchProfiles()

      }
    },
    complete: () => {
      this.isLoading = false;
    },
  });
},
show_questions() {

  const personal_profile = this.type_of_profile.find(
    (profile) => profile.name.toLowerCase() === 'personal'
  );
  const payload = {
    filter_values: {
      profile_type_id:  personal_profile.id,
    },
  };
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
    type: "POST",
    headers: {
      Authorization: `Token ${get_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(payload),
    success: (response) => {
      this.profile_questions = response.data;
    },
  });
},

  save_field_visibility() {
    const payload = {};
    payload[this.currentField] = this.currentVisibility;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_profile_visibility/`,
    type: 'POST',
    headers: {
      Authorization: `Token ${get_token()}`,
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(payload),
    success: () => {
      this.get_profile()
  $('#visibility_modal').modal('hide')

    },
    error: (err) => { console.error('Error occurred:', err); }
  });
},
open_visibility_modal(field) {
  this.currentField = field;

  const visibilityArray = Object.entries(this.profileData.visibility || {}).map(([field, value]) => ({ field, value }));
  const setting = visibilityArray.find(s => s.field === field);
  this.currentVisibility = setting ? setting.value : false;

  this.showVisibilityModal = true;
  $('#visibility_modal').modal('show')
},

  is_section_fully_answered(section) {
  return section?.section?.question_sections?.every(qa => {
    if (!qa.question?.is_mandatory) return true;

    const value = qa.newAnswer ?? qa.answer;

    if (Array.isArray(value)) {
      return value.some(v => v !== null && v !== undefined && v !== "");
    }

    return value !== null && value !== undefined && value.toString().trim() !== "";
  });
},
processAnswer(qa) {
  const combined_answers = qa.newAnswer || qa.answer;

  // Filter duplicates and falsy values if it's an array
  const filtered_answers = Array.isArray(combined_answers)
    ? combined_answers.filter((v, i, self) => v && self.indexOf(v) === i)
    : combined_answers;

  // Join array answers to string, else keep as is
  const answer = Array.isArray(filtered_answers) ? filtered_answers.join(",") : filtered_answers;

  const string_answer = typeof answer === "string" ? answer.trim() : answer;

  // Simple helper for required validation
  const isEmpty = val =>
    val === null || val === undefined || val === "" || (Array.isArray(val) && val.length === 0);

  const has_error = qa.question?.is_mandatory && isEmpty(string_answer);

  return ({ answer, has_error });
},

  submit_all_answers() {
  this.isSubmitting = true; 
  const base_profile_id = this.profileData?.base_profile?.id;

        const all_qa = this.all_section.flatMap(section =>
          section.section?.question_sections || []
        );
      let has_validation_error = false;  // track validation errors

        const answers = all_qa
        .filter(qa => qa.isChanged)
        .map(qa => {
          const result = this.processAnswer(qa);
          if (result.has_error) {
            qa.validation_error = "This field is required.";
            has_validation_error = true;
            return null;
          }
          qa.validation_error = null;
          return {
            question_id: qa.question.id,
            answer: result.answer
          };
        })
      .filter(Boolean);

      if (has_validation_error) {
        this.isSubmitting = false;
        return;
      }
  const payload = {
    base_profile_id: base_profile_id,
    answers: answers,
  };

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/answer_questions_for_base_profile/`,
    type: "POST",
    headers: {
      Authorization: `Token ${get_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(payload),
    success: (response) => {
      if (response.status === "success") {
        // Update local profileData.answers
        for (const ans of answers) {
          const question = all_qa.find(qa => qa.question.id === ans.question_id)?.question;
          if (!question) continue;

          const existing = this.profileData.answers.find(a => a.question.id === ans.question_id);
          if (existing) {
            existing.answer = ans.answer;
          } else {
            this.profileData.answers.push({
              question,
              answer: ans.answer,
            });
          }
        }
        this.allEditing = false;
        all_qa.forEach(qa => {
          qa.isEditing = false;
          qa.isChanged = false;
        });
      }
    },
  });
},

  initialize_answers() {
    this.all_section.forEach(section => {
                section.section?.question_sections?.forEach(qa => {
                  const ansObj = this.profileData.answers?.find(ans => ans.question.id === qa.question.id);
                  if (ansObj) {
                    if (qa.question.question_type.question_type === 'checkbox') {
                      qa.newAnswer = ansObj.answer ? ansObj.answer.split(',') : [];
                    } else {
                      qa.newAnswer = ansObj.answer || '';
                    }
                  } else {
                    qa.newAnswer = qa.question.question_type.question_type === 'checkbox' ? [] : '';
                  }
                  qa.isChanged = false;
                });
                const full = this.is_section_fully_answered(section);
              this.fully_answered_sections[section.section.id] = full;
              });
 },
 
 initializeQuestionAnswer(qa) {
   const savedAnswerObj = this.profileData.answers.find(
     ans => ans.question.id === qa.question.id
   );
 
   if (savedAnswerObj) {
     const ans = savedAnswerObj.answer || '';
     
     if (qa.question.question_type.question_type === 'checkbox') {
       qa.newAnswer = ans ? ans.split(',').map(a => a.trim()) : [];
     } else {
       qa.newAnswer = ans;
     }
   } else {
     qa.newAnswer = qa.question.question_type.question_type === 'checkbox' ? [] : '';
   }},


paginated_questions(questions) {
    const start = (this.question_page - 1) * this.questions_per_page;
    return questions.slice(start, start + this.questions_per_page);
  },
  total_puestion_pages(questions) {
    return Math.ceil(questions.length / this.questions_per_page);
  },
  change_question_page(page) {
    // Always use the current section's questions for page count
    const section = this.all_section.find(s => 'section_' + s.sectionId === this.activeTab);
    const questions = section && section.section && Array.isArray(section.section.question_sections)
      ? section.section.question_sections
      : [];
    const totalPages = this.total_puestion_pages(questions);
    if (page >= 1 && page <= totalPages) {
      this.question_page = page;
    }
  },
  // Helper to get current section's questions
  get currentSectionQuestions() {
    if (!Array.isArray(this.all_section)) return [];
    const section = this.all_section.find(s => 'section_' + s.sectionId === this.activeTab);
    return section && section.section && Array.isArray(section.section.question_sections)
      ? section.section.question_sections
      : [];
  },

last_question_page(section) {
  const total = this.total_puestion_pages(section.section.question_sections);
  return this.question_page === total;
},
handle_next_page(section) {
  const paged_question = this.paginated_questions(section.section.question_sections);
  let hasError = false;

  paged_question.forEach(qa => {
    const val = Array.isArray(qa.newAnswer || qa.answer)
      ? (qa.newAnswer || qa.answer).filter(v => v).join(",")
      : (qa.newAnswer || qa.answer || "").toString().trim();

    if (qa.question?.is_mandatory && !val) {
      qa.validation_error = "This field is required.";
      hasError = true;
    } else {
      qa.validation_error = null;
    }
  });

  if (hasError) return;

  // Move to next page
  this.question_page++;
},

  },
};